import { React, useState, useEffect } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { energyOptions, dataTypeOptions } from "../common/commonVal";
import { getToday, getNow, getMonthByDate } from "../common/commonMethod";
import { nodeDataArray_sihwa, linkDataArray_sihwa, nodeDataArray_inchon_steam, linkDataArray_inchon_steam , nodeDataArray_inchon_air,linkDataArray_inchon_air,nodeDataArray_ansan_steam,linkDataArray_ansan_steam} from "./helper/UI_1_5.helper";
import FxRoutingDiagram  from "../components/FxRouthingDiagram";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { getInloInfo } from "../common/commonMethod";
import { FxWindow } from "./../../fxms/windows/FxWindows";
import dayjs from 'dayjs';

/**
 * @description 수요공급예측 > 라우팅시뮬레이션
 * @author SONJIEUN
 * @date 01/20/2025
 * @param {*}
 * @return  수요공급예측 > 라우팅시뮬레이션
 */
export const UI_1_6 = () => {
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo), user);

  const [fetchEnergyOption, setFetchEnergyOption] = useState(energyOptions);
  const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
  const [fetchTableData, setFetchTableData] = useState([]); // 테이블 데이터
  const [fetchSourcelist, setFetchSourcelist] = useState([]);
  const [fetchSinklist, setFetchSinklist] = useState([]);
  const [nodeDataArray, setNodeDataArray] = useState([]);
  const [linkDataArray, setLinkDataArray] = useState([]);
  const [checkMaxOver, setCheckMaxOver] = useState(true);
  const [tableHtml, setTableHtml] = useState([]);
  const [selected, setSelected] = useState({
    complexInloNo: user.ugrpNo === 1021 || user.ugrpNo === 1024 ? inlo.complexInloNo : "",
    energy: "",
    dataType: "",
    startDate: getMonthByDate(-6), //testData: '20250515' // default : 최대 6개월전~ 당일
    endDate: getToday(), //testData: '20250515'
    dataType: "",
    sinkInlo : user.ugrpNo === 1024? inlo.inloNo : "",
  });

  useEffect(() => {
    if (user.inloClCd === "PROJECT" || user.inloClCd === "COMPLEX") {
      getComplexInloData();
    }
  }, []);

  useEffect(() => {
    console.log("selected :::: >>>", selected);
  }, [selected])

  useEffect(() => {
    selectedComplex(selected.complexInloNo);    
  }, [selected.energy])

  useEffect(() => {
    setSelected((prev) => ({ ...prev, energy: "" }));
    setNodeDataArray([]);
    setLinkDataArray([]);
    setFetchTableData([]);  

  }, [selected.complexInloNo])

  useEffect(() => {
   
  }, [fetchSinklist])

  const getComplexInloData = async () => {
    const uri = "vup/getComplexInloList"
    try {
      const res = await FxmsData.GET(uri);
      if (user.inloClCd === "PROJECT") {
        setFetchComplexInlo(res.data);
      } else {
        setFetchComplexInlo(res.data[0]);
        setSelected((prev) => {
          return { ...prev, complexInloNo: res.data[0].inloNo };
        });
      }
      console.log("complex List >> ", res.data);
    } catch (e) {
      console.log("getComplexInloList error ........", e);
    }
  }

  const getSinkList = async () => {
    if (selected.complexInloNo === '' || selected.energy === ''|| selected.dataType ==='') return;

    const uri = "vup/getSourceSinkList/" + selected.complexInloNo + '/' + selected.energy + '/' + 'sink';;
    try {
      const res = await FxmsData.GET(uri);
      setFetchSinklist(res.data);     
      return res.data;
    } catch (e) {
      console.log("getSourceList error ........", e);
    }
  }

  const getSourceList = async (sinkLength) => {   

    const uri = "vup/getSourceSinkList/" + selected.complexInloNo + '/' + selected.energy + '/' + 'source';;
    try {
      const res = await FxmsData.GET(uri);
      setFetchSourcelist(res.data);
      
     if(sinkLength===0) return;
      
      return res.data;
    } catch (e) {
      console.log("getSourceList error ........", e);
    }
  }

  const selectedComplex = async (value) => {
    setSelected((prev) => ({ ...prev, complexInloNo: value }));

    let energylist = energyOptions;

    if (value === '11000' || value === 11000 ) {
          energylist = energyOptions.filter(x => (x.value === "AIR"));
          setFetchEnergyOption(energylist);
        } else if (value === '14000' || value === 14000 ) {
          energylist = energyOptions.filter(x => (x.value === "STEAM"));
        }    
    resetFetchData();
    setFetchEnergyOption(energylist);   
      
  }

  const handleSelectData = (event) => {
    const { value, name } = event.target;
    setSelected((prev) => {
      return { ...prev, [name]: value };
    }) 

    if (value === "" ) {
      resetFetchData();
    }        
  }


  const handleSelectDataPicker = (name, value) => {
  setSelected((prev) => ({
    ...prev,
    [name]: value, // dayjs 객체 저장
  }));

  if (!value) {
    resetFetchData();
  }
};

  const resetFetchData = () =>{
    setFetchSinklist([]);
    setFetchSourcelist([]);
  }

  
  const handleDataSelectData = (e) => {
  const { name, value } = e.target;

  setSelected((prev) => ({
    ...prev,
    [name]: value,     // dataType 변경
    startDate: getMonthByDate(-6),     // 날짜 초기화
    endDate: getToday(),       // 날짜 초기화
  }));
};
  const handleSimulationData = (event,tableData ,maxList) => {
    const { id, value, name } = event.target;   
      
     let tmpTableData = [...tableData];
    
      if(name === "sourceInlo"){
        tableData[id].sourceInloNo = Number(value);
        tableData[id].sourceInloName = fetchSourcelist.find(item=>item.inloNo=== tableData[id].sourceInloNo).inloName;
      }else if(name === "sourceVal"){
        tmpTableData[id].flowRate =  Number(value);      
      }

     checkSourceMax(tmpTableData,id ,maxList)              
      
    console.log("tmpTableData........" , tmpTableData);       
   
    setFetchTableData(tmpTableData);
  }

  // 조회 버튼 클릭 시 데이터 GET 함수
  const submitBtnClick  = async ()=> {
   
    if (selected.complexInloNo === "") {
      alert("사업장을 선택해주세요.");
      return;
    }
    if (selected.energy === "") {
      alert("에너지 종류를 선택해주세요.");
      return;
    }
    if (selected.dataType === "") {
      alert("데이터 종류를 선택해주세요.");
      return;
    }
    setFetchTableData([]);
    const param = {    
      complexInloNo : selected.complexInloNo,
      startDate: selected.startDate.replace(/-/gi, ""),  
      endDate: selected.dataType === "fixDate"    ? (selected.endDate?.format        ? selected.endDate.format("YYYYMMDDHHmmss")        : selected.endDate.replace(/-/g, "") + "000000")    : selected.endDate.replace(/-/g, ""),
      dataType : selected.dataType,
      energy : selected.energy,
    }

    try {
      const uri = "vup/select_1_6";
      const res = await FxmsData.GET(uri, param);
      console.log("UI_1_6 res........", res.data)

      const sinkList = await getSinkList();
      const sourceList = await getSourceList(sinkList.length); 
      const maxList = await getMaxVal();

      setFetchTableData(res.data);

      makeTable(res.data, sourceList, maxList);

      makeNodeLinkInfo(res.data); // 다이어그램(go.js) 노드 정보 표시

    }catch (e) {
      console.log("UI_1_6 fetchData error", e);
    } 
  };

  const simulationBtnClick = async () => { 
    /*고기원 API 개발 전*/  
    console.log("simulationBtnClick" , fetchTableData)
    FxWindow.alert("API 개발 후 적용 예정", true);
  };

  const checkSourceMax = (tabledata, id, maxList) => {

    const targetSourceInlo = tabledata[id].sourceInloNo;
    let totalFlowRate = 0;

    for (const key in tabledata) {
      const { flowRate, sourceInloNo } = tabledata[key];
      if (sourceInloNo === targetSourceInlo) {
        totalFlowRate += flowRate;
      }
    }
    var maxInlo = maxList.find((item) => item.inloNo === targetSourceInlo);

    if (maxInlo === undefined || maxInlo.maxSourceVal === 0) {
      FxWindow.alert("해당 사업장의 최대수용량이 등록되지 않아 시뮬레이션이 불가합니다.", true); // 모든 산단 설비 등록후 메세지 삭제     
      setCheckMaxOver(true);
      return true;

    } else if (maxInlo.maxSourceVal < totalFlowRate) {
      FxWindow.alert("SOURCE기업 공급 가능 유량을 초과했습니다. 입력값을 확인하세요 (최대수용량:" + maxInlo.maxSourceVal + ")", true);
      setCheckMaxOver(true);
      return true;
    }

    setCheckMaxOver(false);
    return false;
  }

  const getMaxVal = async() => { //산단의 사업장별 합계를 가져옴 현재는 시화만 max값이이 등록되어 있어 시화만 가져옴
    const uri = "vup/getSourceMax/"  + selected.complexInloNo + "/"+ selected.energy;
    try {
      const res = await FxmsData.GET(uri); 
      return res.data;    
    } catch (e) {
      console.log("getMaxVal error ........", e);
    }    
  }

  const deepClone = (obj) => structuredClone ? structuredClone(obj) : JSON.parse(JSON.stringify(obj));


  const makeNodeLinkInfo = (tableData) => {
    let nodeDataArray = [];
    let linkDataArray = [];
    let tmpNodeDataArray = [];
    let tmpLinkDataArray = [];

    if (selected.complexInloNo === '11000' || selected.complexInloNo === 11000) {
          nodeDataArray = nodeDataArray_sihwa;
          linkDataArray = linkDataArray_sihwa;
    }else if ((selected.complexInloNo === '13000' && selected.energy==="STEAM") || (selected.complexInloNo === 13000 && selected.energy === "STEAM")) {
          nodeDataArray = nodeDataArray_inchon_steam;
          linkDataArray = linkDataArray_inchon_steam;
    }else if ((selected.complexInloNo === '13000' && selected.energy==="AIR") || (selected.complexInloNo === 13000 && selected.energy === "AIR")) {
          nodeDataArray = nodeDataArray_inchon_air;
          linkDataArray = linkDataArray_inchon_air;
    }else if ((selected.complexInloNo === '14000' && selected.energy==="STEAM") || (selected.complexInloNo === 14000 && selected.energy === "STEAM")) {
          nodeDataArray = nodeDataArray_ansan_steam;
          linkDataArray = linkDataArray_ansan_steam;
    }

       let sourceList = [];
    tmpNodeDataArray = deepClone(nodeDataArray);
    tmpLinkDataArray = deepClone(linkDataArray);

    // 소스 정보 주입 
    tmpNodeDataArray.forEach(node => {
      
      const item = tableData.find(o => o.sinkInloNo === node.inloNo); 
      if (item) node.sourceInlono = item.sourceInloNo;
    });

      /*사업장은 경로와 노드 빨간색으로 표시*/
      if (user.ugrpNo === 1024) {
        const sourceInlo = tableData.find(n => n.sinkInloNo === selected.sinkInlo).sourceInloNo;
        let key = [];

        //노드 red 추가
        tmpNodeDataArray.forEach((value) => {
          if (value.inloNo === selected.sinkInlo ) {
            value.color = "#2cc01eff"; // 객체에 color 속성 추가
            key.push(value.key);
          }else if ( value.inloNo === sourceInlo)
          {
            value.color = "#1e90ff"; // 객체에 color 속성 추가
            key.push(value.key);
          }
        });

        //경로 red 추가
        if (key.length === 2) {
          let strtKey = key[0] < key[1] ? key[0] : key[1];
          let endKey = key[0] > key[1] ? key[0] : key[1];
          let current = strtKey;

          while (current !== endKey) {
            const link = tmpLinkDataArray.find(item => item.from === current);
            if (!link) break; // 중간에 끊기면 종료
            link.color = 'red'; // 색상 변경
            current = link.to;  // 다음 노드로 이동
          }
        }


        const sinkInfo = tableData.find(n => n.sinkInloNo === selected.sinkInlo); 
        const sinkNode = nodeDataArray.find(n => n.inloNo === selected.sinkInlo); 
        const sinkLoc = sinkNode.loc.split(' ');  
            
        const x = Number(sinkLoc[0]);
        const y = Number(sinkLoc[1]);  
      
        tmpNodeDataArray.push( { category: "sinkSourceInfo", inloName: sinkInfo.sinkInloName , group: "sink", flowRate: `${sinkInfo.flowRate ?? 0}   Nm3/h`, pressureLoss: `${sinkInfo.pressureLoss ?? 0} bar_g`, loc: x + " " + (y-50) })
      
         //싱크주입
        const sourceInfo = tableData.find(  n => n.inloType === "SOURCE" && n.sourceInloNo === sinkInfo.sourceInloNo);
        const sourceNode = nodeDataArray.find(n => n.inloNo === sourceInfo.sourceInloNo);
        const souceLoc = sourceNode.loc.split(' ');
        const x1 = Number(souceLoc[0]);
        const y1 = Number(souceLoc[1]); 

        tmpNodeDataArray.push( { category: "sinkSourceInfo", inloName: sourceInfo.sourceInloName , group: "source", flowRate: `${sourceInfo.flowRate ?? 0}   Nm3/h`, pressureLoss: `${sourceInfo.pressureLoss ?? 0} bar_g`, loc: x1 + " " + (y1+50) })

       //자기가 싱크인 경우 자기 정보도 주입 

        const sourceInfo2 = tableData.find(  n => n.inloType === "SOURCE" && n.sourceInloNo === sinkInfo.sinkInloNo);
        const sourceNode2 = nodeDataArray.find(n => n.inloNo === sourceInfo2.sourceInloNo);
        const souceLoc2 = sourceNode2.loc.split(' ');
        const x2 = Number(souceLoc2[0]);
        const y2 = Number(souceLoc2[1]); 
         tmpNodeDataArray.push( { category: "sinkSourceInfo", inloName: sourceInfo2.sourceInloName , group: "source", flowRate: `${sourceInfo2.flowRate ?? 0}   Nm3/h`, pressureLoss: `${sourceInfo2.pressureLoss ?? 0} bar_g`, loc: x2 + " " + (y2+50) })
         
      }else{

        tableData.map((item) => {
          const sinkNode = nodeDataArray.find(n => n.inloNo === item.sinkInloNo); 
          const sinkLoc = sinkNode.loc.split(' ');
          /*sink 정보는 모두 넣어주고 Source 정보는 최신 정보 한개만 넣어준다.*/
          /*group이 source면 정보위치가 x=x, y= y+50 , sink면 정보위치가 x=x, y= y-50*/     
          
          const x = Number(sinkLoc[0]);
          const y = Number(sinkLoc[1]);  
          if(item.inloType === "SINK")
          {
            tmpNodeDataArray.push( { category: "sinkSourceInfo", inloName: item.sinkInloName , group: "sink", flowRate: `${item.flowRate ?? 0}   Nm3/h`, pressureLoss: `${item.pressureLoss ?? 0 } bar_g`, loc: x + " " + (y-50) })
          }else{
          //Source 정보 주입 
            const sourceNode = nodeDataArray.find(n => n.inloNo === item.sourceInloNo);
            const souceLoc = sourceNode.loc.split(' ');
            const x = Number(souceLoc[0]);
            const y = Number(souceLoc[1]); 
            tmpNodeDataArray.push( { category: "sinkSourceInfo", inloName: item.sourceInloName , group: "source", flowRate: `${item.flowRate ?? 0}   Nm3/h`, pressureLoss: `${item.pressureLoss ?? 0} bar_g`, loc: x + " " + (y+50) })
            sourceList.push(item.sourceInloNo); 
          }
          
          
          })

      }
    
    setNodeDataArray(tmpNodeDataArray);
    setLinkDataArray(tmpLinkDataArray);
  }

  const makeTable = (tableData, sourceList, maxList) => {  

    const tableHtml = [];    

    const sourceListOptions = sourceList.map((item, i) => (
      <option key={i} value={item.inloNo} name="sourceInlo">
        {item.inloName}
      </option>
    ));

    tableHtml.push(
      <tbody key="tbody">
        <tr>
          <th>Sink</th>
          {
            tableData.map((item) => (
              <td>{item.sinkInloName}</td>
            ))
            }
        </tr>
        <tr>
          <th>Source</th>
          {
            tableData.map((item, i) => (
              <td>
               
                <select style={{ textAlign: "center" }} id={i} defaultValue={item.sourceInloNo.toString()} name="sourceInlo" onChange={(e)=>handleSimulationData(e,tableData,maxList)}>
                   {sourceListOptions}    
                </select>
              </td>
            ))
          }
        </tr>        
        <tr>
          <th>수요량(Nm3/h)</th>
          {
              tableData.map((item,i) => (
                <td>
                  <input type="number" step="0.01" id={i} defaultValue={selected.dataType !== "none" ? item.flowRate : null } name="sourceVal" onChange={(e)=>handleSimulationData(e,tableData,maxList)} />
                  </td>
              ))
          }
        </tr>
        <tr>
          <th>압력손실(bar)</th>
          {
              tableData.map((item) => (
                <td>{selected.dataType !== "none" ?item.pressureLoss:null}</td>
              ))
            }
        </tr>
      </tbody>
    );

    setTableHtml(tableHtml); 
  }


  return (
    <>
      <div className="predict">
        <div className="FxCrudFilter">
          <div className="FxFilterLeft">
          {user.ugrpNo === 1021 || user.ugrpNo === 1024 ?
          <select className="FxSelectSearch" value={inlo.complexInloNo}>
           <option value={inlo.complexInloNo}> {inlo.complexInloName} </option>
           </select>
            :
            <select className="FxSelectSearch" onChange={(e) => selectedComplex(e.target.value)}>
                <option value="">산업단지 전체</option>
                {fetchComplexInlo.map((item) => (
                  <option key={item.inloNo} value={item.inloNo} name="complexInloNo">
                    {item.inloName}
                  </option>
                ))}
            </select>
            } 
            <label className="FxLabelSearch"></label>
            <select className="FxSelectSearch" name="energy" value={selected.energy} onChange={handleSelectData}>
              <option value="">에너지 종류</option>
              {fetchEnergyOption.map((item, index) => (
                <option key={index} value={item.value} name="energy">{item.label}</option>
              ))}
            </select>
            <label className="FxLabelSearch"></label>
            <select className="FxSelectSearch" name="dataType" onChange={handleDataSelectData}>
              <option value="">데이터 선택</option>
              {dataTypeOptions.map((item, index) => (
                <option key={index} value={item.value} name="dataType">{item.label}</option>
              ))}
            </select>
          </div>
          <div className="FxFilterRight">
            {selected.dataType === "fixDate" ?
              <>
                <div className="MuiFxDate">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker minutesStep="15" name="endDate" defaultValue={dayjs(getToday())} onChange={(value) => handleSelectDataPicker("endDate", value)} />
                  </LocalizationProvider>                  
                </div>
              </>
              :
              selected.dataType === "highLoad" || selected.dataType === "lowLoad" ?
                <><input className="FxDate" type="date" name="startDate" value={selected.startDate} onChange={handleSelectData} />
                  <label className="FxLabelSearch">~</label>
                  <input className="FxDate" type="date" name="endDate" value={selected.endDate} onChange={handleSelectData} />
                  </>
                : null}    
                <input className="FxButtonSearch" type="button" value="조회" onClick={submitBtnClick} />        
          </div>
        </div>
        <div className="FxCrudDataGrid">
          <div className="vupReportTitle">
            <strong>라우팅 시뮬레이션</strong>
            <div className="legend">
              <span></span>
              수요예측값
            </div>
          </div>
          {fetchSinklist.length !== 0 ? <FxRoutingDiagram tableInput="true" nodeData={nodeDataArray} linkData={linkDataArray} selectedSink={selected.sinkInlo} selectedSource={selected.sourceInlo} ugrpNo={user.ugrpNo} /> : <FxRoutingDiagram />}
          
          <div className="vupSimulatorWrap">
            <strong>수요/공급 예측 기반 라우팅 시뮬레이션</strong>
            <input className="FxButtonSearch" type="button" disabled={checkMaxOver} value="시뮬레이션" onClick={simulationBtnClick} />
            {fetchTableData.length !== 0 ?
              <div className="FxMuiTable">
                <table>
                  <colgroup>
                    <col />
                  </colgroup>
                  <thead>
                  </thead>
                  {tableHtml}
                </table>
              </div> :
              <div class="FxMuiTable">
                <table>
                  <colgroup>
                  </colgroup>
                  <thead>
                  </thead>
                  <tbody>
                    <tr>
                      <th>
                            {selected.complexInloNo === "" ||
                            selected.energy === ""
                              ? "필터를 선택해주세요"
                              : "데이터가 없습니다."}
                          </th>
                    </tr>
                  </tbody>
                </table>
              </div>}
          </div>
        </div>
      </div>
    </>
  )
}